
<div class="day-of-week-picker-container">
  <button class="btn btn-primary right-margin" (click)="onClickAll()">All</button>

  <div class="divTable day-pick-table">
    <div class="divTableHeading">
      <div class="divTableRow">
        @for (day of days; track day) {
          <div class="divTableHead">
            {{ day.abbreviation }}
          </div>
        }
      </div>
    </div>
    <div class="divTableBody">
      <div class="divTableRow">
        @for (day of days; track day) {
          <div class="divTableCell">
            <input type="checkbox" [checked]="day.selected" (change)="onCheckBoxChange(day, $event)" />
          </div>
        }
      </div>
    </div>
  </div>

  <button class="btn btn-default left-margin" (click)="onClickNone()" >None</button>

</div>
